<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <v-card-title class="color">Customer Service</v-card-title>
        <div class="service">
          <v-card flat class="card1 whatsapp">
            <div>
              <img
                src="../assets/whatsapp.png"
                alt="teller logo"
                width="55"
                height="55"
              />
            </div>
            <v-card-title class="txt">Chat us on WhatsApp</v-card-title>
            <p class="contact">+234 8188964415</p>
            <p class="contact">+234 8169602155</p>
          </v-card>
          <v-card flat class="card1 email">
            <div>
              <img
                src="../assets/mail.png"
                alt="teller logo"
                width="39.6"
                height="30"
              />
            </div>
            <v-card-title class="txt">Email us</v-card-title>
            <p class="contact">help@teller.ng</p>
          </v-card>
          <v-card flat class="card1 phone">
            <div>
              <img
                src="../assets/phone2.png"
                alt="teller logo"
                width="38"
                height="38"
              />
            </div>
            <v-card-title class="txt">Call us on Phone</v-card-title>

            <p class="contact">+234 8169602155</p>
            <p class="contact">+234 8188964415</p>
          </v-card>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";

export default {
  metaInfo: {
    title: "Teller/Customer Services",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
  },
};
</script>
<style scoped>
.txt {
  font-family: AvenirLTPro-85;
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: #000000;
}

.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.color {
  color: #ad1684;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.bg1 {
  background-color: rgba(187, 107, 217, 0.3);
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
}
.card1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 240px;
  height: 220px;
  margin: 30px;
  border-radius: 20px;
  padding-top: 34px;
}

.card1 h5 {
  margin-top: 5px;
  color: black;
}
.whatsapp {
  background-color: rgba(67, 197, 83, 0.24);
}
.email {
  background-color: rgba(213, 75, 61, 0.24);
}
.phone {
  background-color: rgba(0, 108, 162, 0.24);
}
.card0 {
  padding: 30px;
  min-height: 250px;
  border-radius: 15px !important;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}
.service {
  display: flex;
  flex-wrap: wrap;
}
.card0 h4 {
  margin: 20px;
}
.cardv {
  height: 450px;
}
.cardRR {
  height: 300px;
  overflow: scroll;
  padding-bottom: 10px;
}
.init {
  margin-left: 15px;
}
.contact {
  font-family: AvenirLTPro-55Roman;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #000000;
}

@media only screen and (max-width: 1024px) {
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 0px;
    padding-top: 70px;
  }
  .card0 {
    padding: 0px;
    min-height: 250px;
    border-radius: 15px !important;
    display: flex;
    flex-wrap: wrap;
    margin: 20px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
